<template>
  <div class="product-grid-container">
    <!-- 产品卡片列表 -->
    <div class="product-card" v-for="(item, index) in productList" :key="index" @click="$router.push(item.path)">
      <!-- 卡片图片区域 -->
      <div class="card-img-wrapper">
        <img :src="item.image" :alt="item.title" class="card-img" />
        <!-- 黑色标题栏 -->
        <!-- <div class="card-title-bar"></div> -->
      </div>
      <!-- 卡片描述区域 -->
      <div class="card-desc">
        <h3 class="card-title">{{ $t(item.titleKey) }}</h3>
        <p>{{ $t(item.descKey) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductGrid',
  data() {
    return {
      // 产品数据（完全匹配截图，可自行修改）
      productList: [
        {
          titleKey: 'home.products.fusion.title',
          descKey: 'home.products.fusion.desc',
          image: require('@/assets/img/Home/product/ai-ronghe.jpg'),
          path:'/Products/index?id=cp001'
        },
        {
          titleKey: 'home.products.deviceExpert.title',
          descKey: 'home.products.deviceExpert.desc',
          image: require('@/assets/img/Home/product/ai-expert.webp'),
          path:'/Products/index?id=cp002'
        },
        {
          titleKey: 'home.products.digitalHuman.title',
          descKey: 'home.products.digitalHuman.desc',
          image: require('@/assets/img/Home/product/问煤.png'),
          path:'/Products/index?id=cp003'
        },
        {
          titleKey: 'home.products.edgeDevice.title',
          descKey: 'home.products.edgeDevice.desc',
          image: require('@/assets/img/Home/product/explosion-proof.webp'),
          path:'/Products/index?id=cp004'
        },
        {
          titleKey: 'home.products.specialRobot.title',
          descKey: 'home.products.specialRobot.desc',
          image: require('@/assets/img/Home/product/robot.webp'),
          path:'/Products/index?id=cp005'
        },
        {
          titleKey: 'home.products.coalClaw.title',
          descKey: 'home.products.coalClaw.desc',
          image: require('@/assets/img/Home/product/ai-assistant.webp'),
          path:'/Products/index?id=cp006'
        }
      ]
    }
  }
}
</script>

<style scoped>
/* 容器：2行3列网格布局 */
.product-grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3列等宽 */
  gap: 24px; /* 卡片间距 */
  padding: 4vh 16vh; /* 整体内边距，可根据页面调整 */
  background: #FFFFFF; /* 页面背景色，匹配截图浅灰 */
}

/* 单个卡片 */
.product-card {
  //height: 422px;
  background: #F8F9FA;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  cursor: pointer;
}

/* 卡片hover效果（可选，提升交互感） */
.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0,0,0,0.12);
}

/* 图片+标题栏容器 */
.card-img-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/* 卡片图片 */
.card-img {
  width: 100%;
  height: 28vh;
  //object-fit: cover; /* 图片自适应，不变形 */
  object-position: center;
}

/* 黑色标题栏（绝对定位在图片底部） */
.card-title-bar {
  margin-top: 15px;
  width: 100%;
  background: #000;
  padding: 12px 16px;
  box-sizing: border-box;
}

/* 标题文字 */
.card-title {
  color: #000000;
  font-size: 1.3vw;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
  margin-bottom: 1vh;
}

/* 描述区域 */
.card-desc {

  padding: 1.5vh 3vh;
  background: #F8F9FA;
}

/* 描述文字 */
.card-desc p {
  color: #333;
  font-size: 1vw;
  line-height: 1.6;
  margin: 0;
}

/* 响应式适配：平板端2列 */
@media (max-width: 1024px) {
  .product-grid-container {
    grid-template-columns: repeat(2, 1fr);
    padding: 30px 40px;
  }
}

/* 响应式适配：移动端1列 */
@media (max-width: 768px) {
  .product-grid-container {
    grid-template-columns: 1fr;
    padding: 20px;
  }
  .card-img-wrapper {
    height: 20vh;
  }
}
</style>